'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-6a5a8a7f.js');
var React = require('react');
var icons = require('@amzn/stencil-react-components/icons');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

var IconAmazonSmileSVG = icons.createSvg('IconAmazonSmile', // name
new icons.SVGIcon(['M153.6 17.24C135 31 108 38.27 84.8 38.27A124.51 124.51 0 0 1 .75 6.21C-1 4.64.56 2.49 2.66 3.71A169.2 169.2 0 0 0 86.75 26a167.21 167.21 0 0 0 64.14-13.13c3.11-1.31 5.78 2.13 2.71 4.37z', 'M161.34 8.4C159 5.35 145.61 7 139.61 7.68c-1.81.21-2.1-1.37-.46-2.52 10.65-7.48 28.1-5.32 30.13-2.82s-.54 20-10.52 28.37c-1.53 1.28-3 .6-2.31-1.1 2.24-5.61 7.27-18.16 4.89-21.21z'], // paths
{
  viewBox: '0 0 169.93 38.27'
}, // params
10, // height
42 // width
));
var IconAmazonSmile = function IconAmazonSmile(props) {
  return /*#__PURE__*/React__default["default"].createElement(IconAmazonSmileSVG, _rollupPluginBabelHelpers._objectSpread2({
    color: "#f90"
  }, props));
};

var IconAtoZProfileSVG = icons.createSvg('IconAtoZProfile', // name
new icons.SVGIcon([// paths
'M22.099 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM5.166 27.335c.9-4.828 5.375-8.562 10.834-8.562s9.934 3.734 10.834 8.562a.589.589 0 0 1-.163.532.926.926 0 0 1-.671.274H6a.925.925 0 0 1-.671-.274.588.588 0 0 1-.163-.532Z'], {
  width: '32',
  height: '32',
  strokeWidth: '2',
  stroke: 'currentcolor',
  fillOpacity: '0'
}, // params
32, // height
32 // width
));
var IconAtoZProfile = function IconAtoZProfile(props) {
  return /*#__PURE__*/React__namespace.createElement(IconAtoZProfileSVG, _rollupPluginBabelHelpers._objectSpread2({}, props));
};

var IconBenefitsSVG = icons.createSvg('IconBenefits', // name
new icons.SVGIcon([// paths
'M15.716 2.041c.189-.055.39-.055.58 0L27.29 5.256a.97.97 0 0 1 .71.922v6.591a17.04 17.04 0 0 1-3.215 9.96 17.08 17.08 0 0 1-8.456 6.218c-.212.07-.442.07-.654 0a17.081 17.081 0 0 1-8.459-6.219A17.042 17.042 0 0 1 4 12.766V6.178c0-.425.288-.8.71-.923l11.006-3.214ZM6 6.894v5.872c0 3.184 1.002 6.285 2.859 8.862a15.091 15.091 0 0 0 7.143 5.383 15.088 15.088 0 0 0 7.14-5.382A15.159 15.159 0 0 0 26 12.769V6.894l-9.995-2.922L6 6.894Z', 'M22.805 10.158a1 1 0 0 1 .027 1.414l-7.334 7.61a1 1 0 0 1-1.44 0l-4.278-4.44a1 1 0 1 1 1.44-1.387l3.558 3.692 6.614-6.863a1 1 0 0 1 1.413-.026Z'], {
  width: '32',
  height: '32'
}, // params
32, // height
32 // width
));
var IconBenefits = function IconBenefits(props) {
  return /*#__PURE__*/React__namespace.createElement(IconBenefitsSVG, _rollupPluginBabelHelpers._objectSpread2({}, props));
};

var IconEyeSVG = icons.createSvg('IconEye', // name
new icons.SVGIcon(['M8 0C3.582 0 0 5.238 0 5.238s3.582 5.237 8 5.237 8-5.237 8-5.237S12.418 0 8 0zm.06 9.309a4.034 4.034 0 1 1 4.034-4.034A4.035 4.035 0 0 1 8.06 9.309z', // This path is the circle converted to a path.
// <Circle fill='#737e8b' cx={8} cy={5.309} r={1.751} />
// https://thednp.github.io/svg-path-commander/convert.html
'M6.249 5.309a1.751 1.751 0 1 0 3.502 0a1.751 1.751 0 1 0 -3.502 0'], // paths
{
  viewBox: '0 0 16 10.475'
}, // params
16, // height
28 // width
));
var IconEye = function IconEye(props) {
  return /*#__PURE__*/React__default["default"].createElement(IconEyeSVG, _rollupPluginBabelHelpers._objectSpread2({
    color: "#737e8b"
  }, props));
};

var IconInvisibleSVG = icons.createSvg('IconInvisible', // name
new icons.SVGIcon(['M16 7.456S12.453 2.27 8.078 2.27a7.274 7.274 0 0 0-3.837 1.246L.708 0 0 .712l8.439 8.4.091.088 6.377 6.346.708-.712-3.551-3.534A16.06 16.06 0 0 0 16 7.456zM8.137 3.5a3.989 3.989 0 0 1 2.877 6.758L9.4 8.647a1.729 1.729 0 0 0-2.448-2.432L5.359 4.628A3.978 3.978 0 0 1 8.137 3.5zM8.137 11.488A4 4 0 0 1 4.294 6.4L2.619 4.736a16.538 16.538 0 0 0-2.463 2.72s3.544 5.187 7.922 5.187a6.233 6.233 0 0 0 2.1-.383l-.932-.928a3.99 3.99 0 0 1-1.109.156z'], // paths
{
  viewBox: '0 0 16 15.548'
}, // params
16, // height
28 // width
));
var IconInvisible = function IconInvisible(props) {
  return /*#__PURE__*/React__default["default"].createElement(IconInvisibleSVG, _rollupPluginBabelHelpers._objectSpread2({
    color: "#737e8b"
  }, props));
};

var IconSurgePremium = icons.createSvg('IconSurgePremium', // name
new icons.SVGIcon([// paths
'M3.59658656,16 L2.69658656,16 L3.59658656,9.77777778 L0.446586559,9.77777778 C-0.0754134412,9.77777778 -0.0664134412,9.49333333 0.104586559,9.19111111 C0.275586559,8.88888889 0.149586559,9.12 0.167586559,9.08444444 C1.32858656,7.05777778 3.07458656,4.03555556 5.39658656,0 L6.29658656,0 L5.39658656,6.22222222 L8.54658656,6.22222222 C8.98758656,6.22222222 9.05058656,6.51555556 8.96958656,6.67555556 L8.90658656,6.80888889 C5.36058656,12.9333333 3.59658656,16 3.59658656,16 Z'], {
  width: '16',
  height: '16'
}, // params
16, // height
16 // width
));

exports.IconAmazonSmile = IconAmazonSmile;
exports.IconAtoZProfile = IconAtoZProfile;
exports.IconBenefits = IconBenefits;
exports.IconEye = IconEye;
exports.IconInvisible = IconInvisible;
exports.IconSurgePremium = IconSurgePremium;
//# sourceMappingURL=SurgePremium-9eee1b19.js.map
